/**
 * Tela `/solicitar-compra`: o formulário de envio e, abaixo, o histórico do usuário.
 *
 * Papel: monta o título, o `FormularioSolicitacao` e a seção "Seus pedidos" com o
 * `HistoricoDeSolicitacoes`, em uma coluna para celular.
 *
 * Como usar: é a rota que `router.tsx` declara dentro do `LayoutProtegido`. O
 * `Layout` troca a barra para a moldura mínima quando a pessoa só tem a permissão de
 * solicitação, e esta página não precisa saber disso. A página não abre container de
 * largura próprio, porque o `<main>` do `Layout` já dá o respiro lateral; o limite de
 * largura do formulário e do histórico fica nos próprios elementos.
 */
import { FormularioSolicitacao } from '../components/formulario-solicitacao';
import { HistoricoDeSolicitacoes } from '../components/historico-de-solicitacoes';

/**
 * Página de solicitação de compra do funcionário.
 *
 * @returns O título, o formulário de envio e a seção do histórico.
 */
export function PaginaSolicitarCompra() {
  return (
    <div className="flex flex-1 flex-col gap-8 py-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground">Solicitar compra</h1>
        <p className="max-w-md text-sm text-muted-foreground">
          Descreva o que falta comprar e envie. Os pedidos enviados aparecem abaixo.
        </p>
      </header>

      <FormularioSolicitacao />

      <section
        aria-labelledby="titulo-seus-pedidos"
        className="flex w-full max-w-md flex-col gap-3"
      >
        <h2 id="titulo-seus-pedidos" className="text-base font-semibold text-foreground">
          Seus pedidos
        </h2>
        <HistoricoDeSolicitacoes />
      </section>
    </div>
  );
}
